// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"197":"66f83d6df62abd19","810":"a2911fe13e89bd68"}[chunkId] + ".js";
};